import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2403dba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "describe-text" }
const _hoisted_2 = { class: "describe-text" }
const _hoisted_3 = { style: {"margin-top":"-2px"} }
const _hoisted_4 = { class: "button-group" }

import { computed, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import PolicyBindScope from '@/views/dashboard/policy/_components/policy-bind-scope.vue'
import { editToList, PolicyCommonService } from '@/views/dashboard/policy/policy-common.service'
import { PermissionFe } from '@/services/service-permission.service'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import {
  DEFAULT_SETTING,
  SettingsRes
} from '@/views/dashboard/data-safe/usb-manage/usb-policy-edit/usb-policy-edit.service'
import { WhiteList } from '@/views/dashboard/data-safe/usb-manage/usb-policy/usb-policy.service'
import { KUSBSAFEIDTOOL } from '@/config/external-link'

const MAX_WHITE_LIST_LENGTH = 50


export default /*#__PURE__*/_defineComponent({
  __name: 'usb-policy-edit',
  props: {
    drawerMode: { type: Boolean, default: false },
    initialPolicyId: { default: '' },
    initialFromGroupId: { default: undefined },
    policyId: { default: '' },
    fromGroupId: { default: undefined }
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const { t, locale } = useI18n()

const injector = useReflectiveInjector([PolicyCommonService])
const policyCommonService = injector.get(PolicyCommonService)

const isLoading = ref<boolean>(false)
const effectivePolicyId = computed(() =>
  props.drawerMode ? (props.initialPolicyId || '') : (props.policyId || '')
)
const effectiveFromGroupId = computed(() =>
  props.drawerMode ? (props.initialFromGroupId || undefined) : (props.fromGroupId || undefined)
)
const groupEditStrategyOver = computed(() => ({
  type: PolicyType.usbControl,
  current: effectivePolicyId.value,
}))
const strategyData = ref({
  strategy: JSON.parse(JSON.stringify(DEFAULT_SETTING)),
  bind_mode: 0,
  device_ids: [] as string[],
  strategy_group_ids: [] as string[],
} as SettingsRes)
const invalidPeripheralId = ref<boolean>(null)
const invalidRemark = ref<boolean>(null)
const addParams = reactive<WhiteList>({
  peripheral_id: null,
  remark: null
})
const formNode = ref()
const formRules = computed(() => {
  void locale.value
  return {
    name: [
      {
        required: true,
        message: t('usbPolicy.pleaseEnterPolicyName'),
        trigger: 'blur',
      },
    ],
    'strategy.is_remind': [
      {
        required: true,
        message: t('usbPolicy.pleaseSelectStrategyMode'),
        trigger: 'blur',
      },
    ],
    strategy_group_ids: [
      {
        validator: (_rule: unknown, value: unknown, callback: (e?: Error) => void) => {
          const mode = strategyData.value.bind_mode ?? 0
          if (mode === 0 && (!value || !(value as string[]).length)) {
            callback(new Error(t('policyBindScope.needGroups')))
          } else {
            callback()
          }
        },
        trigger: 'change',
      },
    ],
    device_ids: [
      {
        validator: (_rule: unknown, value: unknown, callback: (e?: Error) => void) => {
          const mode = strategyData.value.bind_mode ?? 0
          if (mode === 1 && (!value || !(value as string[]).length)) {
            callback(new Error(t('policyBindScope.needTerminals')))
          } else {
            callback()
          }
        },
        trigger: 'change',
      },
    ],
  }
})

function getSettings () {
  isLoading.value = true
  policyCommonService.getSettings({
    id: effectivePolicyId.value,
    type: PolicySettingType.usbControl
  }).then(response => {
    strategyData.value = response
    /** control_type只能为2, 这里初始化 */
    if (strategyData.value.strategy.control_type !== 2) {
      strategyData.value.strategy.control_type = 2
      strategyData.value.strategy.is_remind = undefined
    }
  }).finally(() => {
    isLoading.value = false
  })
}

async function saveSetting () {
  if (!await checkBeforeSubmit()) {
    return
  }
  policyCommonService.saveSettings({
    id: effectivePolicyId.value,
    strategy: JSON.stringify(strategyData.value.strategy),
    name: strategyData.value.name,
    group_ids: strategyData.value.strategy_group_ids ?? [],
    device_ids: strategyData.value.device_ids,
    bind_mode: strategyData.value.bind_mode ?? 0,
    type: PolicySettingType.usbControl,
    strategy_type: PolicyType.usbControl
  }).then(() => {
    ElMessage.success(t('usbPolicy.editSaveSuccess'))
    if (props.drawerMode) {
      emit('success')
    } else {
      goListPage()
    }
  })
}

async function checkBeforeSubmit () {
  if (!await formNode.value.validate().catch(() => false)) {
    ElMessage.error(t('usbPolicy.editFormError'))
    return false
  }
  return true
}

function cancel () {
  if (props.drawerMode) {
    emit('close')
  } else {
    goListPage()
  }
}

function resetAddParams () {
  addParams.peripheral_id = null
  addParams.remark = null
  invalidPeripheralId.value = null
  invalidRemark.value = null
}

function handleCheckPeripheralId (id: string) {
  if (id === '') {
    invalidPeripheralId.value = null
    return
  }

  const MAX_LENGTH = 32
  if (id.length > MAX_LENGTH) {
    invalidPeripheralId.value = true
    return
  }

  invalidPeripheralId.value = false
}

function handleCheckRemark (remark: string) {
  if (remark === '') {
    invalidRemark.value = null
    return
  }

  const MAX_LENGTH = 255
  if (remark.length > MAX_LENGTH) {
    invalidRemark.value = true
    return
  }

  invalidRemark.value = false
}

function handleDeleteWhiteListItem (removeItem: WhiteList) {
  const index = strategyData.value.strategy.white_list.findIndex(item => item.peripheral_id === removeItem.peripheral_id)
  strategyData.value.strategy.white_list.splice(index, 1)
}

function handleAddDevice () {
  if (strategyData.value.strategy.white_list.length >= MAX_WHITE_LIST_LENGTH) {
    ElMessage.error(t('usbPolicy.whitelistMaxReached', { n: MAX_WHITE_LIST_LENGTH }))
    return
  }
  if (invalidPeripheralId.value === null) {
    invalidPeripheralId.value = true
  }

  if (invalidRemark.value === null) {
    invalidRemark.value = true
  }

  if (invalidPeripheralId.value || invalidRemark.value) {
    return
  }

  if (!strategyData.value.strategy.white_list) {
    strategyData.value.strategy.white_list = []
  }

  if (strategyData.value.strategy.white_list.find(item => item.peripheral_id === addParams.peripheral_id)) {
    resetAddParams()
    return
  }
  strategyData.value.strategy.white_list.unshift(Object.assign({}, addParams))

  resetAddParams()
}

function goListPage () {
  editToList({ path: '/dashboard/usb-policy', fromGroupId: effectiveFromGroupId.value })
}

watch(
  effectivePolicyId,
  (id) => {
    if (id) {
      getSettings()
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(ContentAdaptLayout, { class: "usb-policy-edit-wrap important" }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "cm-ui-ml10",
          size: "small",
          type: "primary",
          onClick: saveSetting
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formNode",
        ref: formNode,
        class: "main-form",
        rules: formRules.value,
        model: strategyData.value,
        "label-position": "left",
        "hide-required-asterisk": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('usbPolicy.editPolicyName'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                size: "small",
                style: {"width":"240px"},
                placeholder: _ctx.$t('usbPolicy.policyNamePlaceholder'),
                modelValue: strategyData.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategyData.value.name) = $event)),
                modelModifiers: { trim: true },
                maxlength: "50"
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            prop: "strategy.is_remind",
            label: _ctx.$t('usbPolicy.strategyMode')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                class: "sub-row",
                modelValue: strategyData.value.strategy.is_remind,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategyData.value.strategy.is_remind) = $event)),
                label: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('usbPolicy.noReadWrite')), 1),
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('usbPolicy.modeBlockReadWriteDesc')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio, {
                class: "sub-row",
                modelValue: strategyData.value.strategy.is_remind,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategyData.value.strategy.is_remind) = $event)),
                modelModifiers: { number: true },
                label: true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('usbPolicy.accessOnApply')), 1),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('usbPolicy.modeApplyApprovalDesc')), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            prop: "watermark_mode",
            label: _ctx.$t('usbPolicy.usbWhitelist')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_space, {
                class: "ctrl-wrap cm-ui-mb10",
                size: 10
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: _ctx.$t('usbPolicy.deviceIdPlaceholder'),
                    size: "small",
                    class: _normalizeClass({ invalid: invalidPeripheralId.value !== null && invalidPeripheralId.value }),
                    modelValue: addParams.peripheral_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addParams.peripheral_id) = $event)),
                    onInput: handleCheckPeripheralId
                  }, null, 8, ["placeholder", "class", "modelValue"]),
                  _createVNode(_component_el_input, {
                    placeholder: _ctx.$t('usbPolicy.remark'),
                    size: "small",
                    class: _normalizeClass({ invalid: invalidRemark.value !== null && invalidRemark.value }),
                    modelValue: addParams.remark,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addParams.remark) = $event)),
                    onInput: handleCheckRemark
                  }, null, 8, ["placeholder", "class", "modelValue"]),
                  _createVNode(_component_el_button, {
                    class: "button-add",
                    type: "primary",
                    size: "small",
                    plain: "",
                    onClick: handleAddDevice
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('usbPolicy.addToWhitelist')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_table, {
                "original-style": "",
                style: {"width":"690px"},
                "max-height": "400",
                data: strategyData.value.strategy.white_list,
                "empty-text": _ctx.$t('common.noData')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('usbPolicy.deviceId'),
                    prop: "peripheral_id"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('usbPolicy.remark'),
                    prop: "remark"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.$t('usbPolicy.columnAction'),
                    width: "100"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        type: "text",
                        class: "cm-link-danger",
                        size: "small",
                        onClick: ($event: any) => (handleDeleteWhiteListItem(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["data", "empty-text"]),
              _createVNode(_component_el_link, {
                class: "cm-ui-mt5",
                href: _unref(KUSBSAFEIDTOOL),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('usbPolicy.downloadToolForDeviceId')), 1)
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            class: "label-line",
            prop: "strategy_group_ids"
          }, {
            label: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('policyBindScope.applyMode')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(PolicyBindScope, {
                  "bind-mode": strategyData.value.bind_mode ?? 0,
                  "group-ids": strategyData.value.strategy_group_ids || [],
                  "device-ids": strategyData.value.device_ids || [],
                  "preset-group-id": effectivePolicyId.value ? undefined : effectiveFromGroupId.value,
                  "permission-key": _unref(PermissionFe).usb_peripheral_control,
                  "strategy-over": groupEditStrategyOver.value,
                  "max-height": 250,
                  "onUpdate:bindMode": _cache[5] || (_cache[5] = ($event: any) => (strategyData.value.bind_mode = $event)),
                  "onUpdate:groupIds": _cache[6] || (_cache[6] = ($event: any) => (strategyData.value.strategy_group_ids = $event)),
                  "onUpdate:deviceIds": _cache[7] || (_cache[7] = ($event: any) => (strategyData.value.device_ids = $event)),
                  onGroupUpdate: _cache[8] || (_cache[8] = ($event: any) => (formNode.value.validateField('strategy_group_ids')))
                }, null, 8, ["bind-mode", "group-ids", "device-ids", "preset-group-id", "permission-key", "strategy-over"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  })), [
    [_directive_loading, isLoading.value]
  ])
}
}

})